<template>
  <v-checkbox
    label="Is base product ?"
    v-model="model.baseProduct"
    :false-value="0"
    :true-value="1"
  ></v-checkbox>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      model: this.catalog,
      loading: false
    };
  },
  props: {
    catalog: {
      type: Object
    }
  },
  watch: {
    "model.baseProduct": function() {
      this.loading = true;
      this.update({
          model: this.model
        })
        .then(data => {
          this.model = data.catalogProduct;
        })
        .finally(() => (this.loading = false));
    }
  },
  methods:{
    ...mapActions("catalogProducts", ["update"])
  }
};
</script>

<style></style>
